import useGetStickyState from 'hooks/search/useGetStickyState';
import React, { useEffect } from 'react';
import CoreRadioChips from 'shared/chips/CoreRadioChips';
import CoreSvg from 'shared/CoreSvg';
import Icon from 'shared/icons';
import useCommonStore from 'store/useCommonStore';
import styled from 'styled-components';
import { StickySectionHeaderRow } from 'styles/styled-components/section';
import style from 'styles/styled-components/style';
import { PlatformCode, PlatformName } from 'type/common';

const chips_arr = [
	'Instagram Top100',
	'Youtube Top100',
	'Naver Blog Top100',
	'TikTok Top100',
];

const code_mapper: Record<PlatformName, PlatformCode> = {
	Instagram: 'ig',
	Youtube: 'yt',
	'Naver Blog': 'nb',
	TikTok: 'tt',
};

const text_mapper: Record<PlatformCode, string> = {
	ig: '팔로워',
	yt: '구독자',
	nb: '누적 방문자 수',
	tt: '팔로워',
};

const RankSelectPlatformRow = ({ bg_dom }: { bg_dom: HTMLElement | null }) => {
	const { platform, setPlatform, setCommonFilter } = useCommonStore();

	/** 플랫폼 칩스 값 변경 */
	const setPlatformChips = (platform_rank_name: string) => {
		const platform_name = platform_rank_name.replace('Top100', '').trim();

		setPlatform({
			name: platform_name as PlatformName,
			code: code_mapper[platform_name as PlatformName],
		});

		// 플랫폼 변경 시 common filter 초기화
		setCommonFilter('order_by', 'random');
		setCommonFilter('order', 'desc');
	};
	/** 플랫폼 값이 비어있을 경우 인스타그램으로 세팅 */
	useEffect(() => {
		if (platform.name === null) setPlatform({ name: 'Instagram', code: 'ig' });
	}, [platform]);

	const [is_sticky, headerRowRef] = useGetStickyState(bg_dom);

	return (
		<StickySectionHeaderRow
			_padding="32px 16px 16px"
			radius={is_sticky ? '0' : '16px 16px 0 0'}
			sticky_top="-16px"
			ref={headerRowRef}
		>
			<style.Grid flex="between">
				<CoreRadioChips
					group_type="carousel"
					style_type="default"
					_width="max-content"
					chips_list={chips_arr}
					selected_chips={platform.name ? `${platform.name} Top100` : ''}
					setSelectedChips={setPlatformChips}
					_disabled={[]}
				/>
				<style.Grid flex="end" _gap="4px" flex_option="0 0">
					<CoreSvg _size="16px">
						<Icon.HelpOutline />
					</CoreSvg>
					<DescText typo="span">
						{text_mapper[platform.code ?? 'ig']}의 <span>성장성, 증가량, 증가율 등</span>{' '}
						다양한 지표를 <span>IMMS 2.0만의 로직</span>으로 환산하여 산정한 랭킹입니다.
					</DescText>
				</style.Grid>
			</style.Grid>
		</StickySectionHeaderRow>
	);
};

const DescText = styled(style.Text)`
	& > span {
		${({ theme }) => theme.typo.body.span_bold};
	}
`;

export default RankSelectPlatformRow;
